import Link from 'next/link'

const ProjectCard = (props) => {
  const { color, url, content, project_type } = props

  let modifier = (color && color !== 'default') ? ` ProjectCard--${color}` : ''

  return (
    // TODO: this replacement and usage of Link in Next.js is not needed in a newer version, we can simply pass the url
    <Link href={`/projects/[slug]`} as={url.replace(process.env.PROJECT_URL, '/')}>
      <a className={`ProjectCard${modifier}`}>
        {content.length & content[0].image.length &&
        <div className="ProjectCard-aside">
          <div className="ProjectCard-figure">
            <img className="ProjectCard-image" src={content[0].image[0].url} alt={content[0].image[0].title} />
          </div>
        </div>
        }
        {content.length &&
        <div className="ProjectCard-main">
          <div className="ProjectCard-content">
            {content[0].title &&
            <div className="ProjectCard-title">
              <p>{ content[0].title }</p>
            </div>
            }
            {project_type[0] &&
            <div className="ProjectCard-label">
              <span className="ProjectCard-labelText">{ project_type[0].title }</span>
            </div>
            }
          </div>
        </div>
        }
      </a>
    </Link>
  )
}

export default ProjectCard
